import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import QuoteModal from '@/components/PowerOcean/Home/QuoteModal';

export default function A({ langKey }: any) {
    const { useLang, useState, gtm } = useGlobal();
    const { t } = useLang(langKey || 'poweroceancollection');
    const [showQuoteModal, setShowQuoteModal] = useState(false);

    const handleLearMore = () => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'solution_button',
                list_name: t('secA_title'),
                button_name: t('secA_btn'),
            });
        } catch (e) {
            console.error(e);
        } finally {
            if (langKey === 'solarspeicher') {
                const target = document.querySelector('.power-ocean-collection-N') as HTMLElement;
                if (target) {
                    window.scrollTo({
                        top: target?.offsetTop,
                        behavior: 'smooth',
                    });
                }
                return;
            }
            setShowQuoteModal(true);
        }
    };

    return (
        <div className={`power-ocean-collection-A ${css['power-ocean-collection-A']}`}>
            <div className="img-box">
                <NextImage
                    src={require('@publicLocal/power-ocean/collection/h5/de/1.jpg')}
                    priority
                    loading="eager"
                    alt={t('secA_title')}
                    // placeholder={t('secA_title')}
                    aria-label={t('secA_title')}
                />
                <div className="text-box">
                    <p className="title">{t('secA_title')}</p>
                    <p className="desc">{t('secA_desc')}</p>
                    {langKey !== 'solarspeicher' && (
                        <span className="btn" onClick={handleLearMore}>
                            {t('secA_btn')}
                        </span>
                    )}
                </div>
            </div>
            {langKey !== 'solarspeicher' && <p className="text">{t('secA_text')}</p>}
            {showQuoteModal && <QuoteModal callback={() => setShowQuoteModal(false)} initType={0} />}
        </div>
    );
}
